import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store/store';

const API_HOST = process.env.REACT_APP_API_HOST;

export interface Category {
  _id?: string;
  name?: string;
  description?: string;
  // Додайте інші поля категорії
  [key: string]: any;
}

export interface CategoryCreateRequest {
  name: string;
  description?: string;
  // Додайте інші поля для створення
  [key: string]: any;
}

export interface CategoryUpdateRequest {
  name?: string;
  description?: string;
  // Додайте інші поля для оновлення
  [key: string]: any;
}

export const categoryApi = createApi({
  reducerPath: 'categoryApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_HOST,
    credentials: 'include',
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info?.api_token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Category'],
  endpoints: (build) => ({
    getCategories: build.query<{ data: Category[]; total: number }, { page?: number; limit?: number; sortBy?: string; sortOrder?: string }>({
      query: (params) => {
        const query = new URLSearchParams();
        if (params.page) query.append('page', params.page.toString());
        if (params.limit) query.append('limit', params.limit.toString());
        if (params.sortBy) query.append('sortBy', params.sortBy);
        if (params.sortOrder) query.append('sortOrder', params.sortOrder);
        
        return {
          url: `category/list?${query.toString()}`,
          method: 'GET',
        };
      },
      providesTags: ['Category'],
    }),
    
    getCategoryById: build.query<Category, string>({
      query: (id) => ({
        url: `category/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Category', id }],
    }),
    
    createCategory: build.mutation<Category, CategoryCreateRequest>({
      query: (data) => ({
        url: 'category/create',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Category'],
    }),
    
    updateCategory: build.mutation<Category, { id: string; data: CategoryUpdateRequest }>({
      query: ({ id, data }) => ({
        url: `category/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Category', id }, 'Category'],
    }),
    
    deleteCategory: build.mutation<void, string>({
      query: (id) => ({
        url: `category/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Category'],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useGetCategoryByIdQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoryApi; 